import { useState } from "react";
import {
  faEnvelope,
  faMapMarkerAlt,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useUI from "../store/store";
import parsePhoneNumber from "libphonenumber-js";
import {baseUrl} from '../utils/urls.js';

import Head from "next/head";
import ContactInput from "../components/ContactInput";

const Contact = () => {
  const showNotification = useUI((state) => state.showNotification);
  const [phone, setPhone] = useState(null);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const isValidPhoneNumber = (p) => {
    const phoneNumber = parsePhoneNumber(p.code + "" + p.number, p.country);
    return phoneNumber.isValid();
  };

  const sendHandler = async (e) => {
    e.preventDefault();
    if (!phone || !isValidPhoneNumber(phone)) {
      alert("Phone Number Not Valid");
      return;
    }
    try {
      setLoading(true);
      await axios.post(baseUrl + "/api/v1/messages/", {
        ...data,
        phone: phone.number,
      });
      showNotification("Message Sent!");
      setLoading(false);
      setPhone({ ...phone, number: "" });
      setData(null);
    } catch (err) {
      console.log(err)
      showNotification("Some Error Occured!");
      setLoading(false);
    }
  };

  return (
    <div>
      <Head>
        <meta
          property="og:image"
          content={
            "https://assets.alanvidyushbaptist.com/optimumwellness_logo.jpg"
          }
        />
        <title>Contact Us | Diet Consultant and Fitness Expert</title>

        <meta
          name="description"
          content="Fill this form and we'll get back to you as soon as possible. You can also call or whatsapp us or even email us to book an appointment."
        />
        <meta name="keywords" content="fitness, health, wellness" />
      </Head>

      <div>
        <div className="row m-0 pt-3 pt-xl-0">
          <div className="col-md-1 col-xl-2 col-xxl-1"></div>
          <div className="col-md-4 col-xl-4 col-xxl-4 m-auto ps-3 pe-3 ps-md-0 pe-md-0">
            <h1 className="fo-46 bco fw-700 lg-40 mfo-32">
              We’d love to <br></br>hear from you.
            </h1>
            <form onSubmit={sendHandler}>
              <input
                required
                className="contactInput mt-4"
                placeholder="Name"
                value={data ? data.name : ""}
                onChange={(e) => setData({ ...data, name: e.target.value })}
              />
              <div>
                <ContactInput
                  value={phone && phone.number}
                  onChange={(value) => setPhone(value)}
                  required
                />
              </div>

              <input
                type="email"
                className="contactInput"
                placeholder="Email"
                required
                value={data ? data.email : ""}
                onChange={(e) => setData({ ...data, email: e.target.value })}
              />
              <textarea
                className="contactTextarea mt-4"
                placeholder="Your Message (Optional)"
                value={data ? data.message : ""}
                onChange={(e) => setData({ ...data, message: e.target.value })}
              ></textarea>
              <button
                type="submit"
                className="btn sendButton pulsating"
                disabled={loading}
              >
                Send
              </button>
            </form>
          </div>
          <div className="col-md-7 col-xl-1 col-xxl-0 p-0 d-xxl-none"></div>
          <div className="col-md-7 col-xl-5 col-xxl-7 m-auto p-0">
            <img
              src="/assets/contact.png"
              className="w-100"
              alt="contactImage"
            ></img>
          </div>
        </div>

        <div className="ps-xl-5 pe-xl-5 mt-5">
          <div className="ps-xl-5 pe-xl-5">
            <div className="row m-0 ps-xl-5 pe-xl-5">
              <div className="col-md-4 text-center mb-5">
                <div className="contactIcon">
                  <FontAwesomeIcon icon={faPhone} />
                </div>
                <div className="fo-16 fw-600 bco mt-3">+91-9836143134</div>
              </div>
              <div className="col-md-4 text-center mb-5">
                <div className="contactIcon">
                  <FontAwesomeIcon icon={faMapMarkerAlt} />
                </div>
                <div className="fo-16 fw-600 bco mt-3">
                  77/C Dilkhusha Street, Kolkata, 700017, India
                </div>
              </div>
              <div className="col-md-4 text-center mb-5">
                <div className="contactIcon">
                  <FontAwesomeIcon icon={faEnvelope} />
                </div>
                <div className="fo-16 fw-600 bco mt-3">
                  contact@optimumwellness.in
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
